module.exports = __webpack_public_path__ + "img/07.9db2102a.jpg";